<div class="container-fluid">
	<div class="row pt-3">
		<div class="mt-3 px-3 col-sm-6 offset-sm-3 notice">
			<p>
				Les prix affichés sont calculés d'après les dernières ventes.
				Ils reflètent donc le marché actuel et sont suceptibles de changer.
				Il est important de noter que le prix dépend de l'état général du boitier
				et s'il est vendu nu ou avec objectif.
			</p>
		</div>
	</div>
	<div class="mobile">
		<div class="row p-3 pt-0">
			<div class="col-md-6 offset-md-3">
				<!-- SELECT BRAND -->
				<div class="row mt-3">
					<div class="col-sm-6 offset-sm-3">
						<mat-form-field class="w-100" *ngIf="brands; else spinner">
							<mat-label>Marque</mat-label>
							<mat-select (selectionChange)="onSelectBrand($event)" [value]="brandIdSelected">
								<mat-option *ngFor="let brand of brands; trackBy: trackById" [value]="brand.id">
									{{brand.name}}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<ng-template #spinner>
							<div class="mt-3">
								<app-spinner [text]="loadingBrandTxt"></app-spinner>
							</div>
						</ng-template>
					</div>
				</div>
				<!-- SELECT MODEL -->
				<div class="row mt-3">
					<div class="col-sm-6 offset-sm-3">
						<mat-form-field class="w-100" *ngIf="brands">
							<mat-label>Modèle</mat-label>
							<mat-select (selectionChange)="onSelectModel($event)" [value]="modelSelected">
								<mat-option *ngFor="let model of models; trackBy: trackById" [value]="model">
									{{model.name}}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<!-- CARD -->
					<div class="col-sm-12 px-0" *ngIf="model">
						<app-model-detail [model]="model"></app-model-detail>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="desktop">
		<div class="row p-5">
			<!-- SELECT BRAND -->
			<div class="select-brand col-sm-3" [class.loading]="!brands">
				<mat-selection-list *ngIf="brands; else spinner" [multiple]="false"
					(selectionChange)="onSelectionBrand($event)" class="p-0">
					<mat-list-option *ngFor="let brand of brands; trackBy: trackById" [value]="brand.id"
						[selected]="isBrandSelected(brand.id)">
						{{brand.name}}
					</mat-list-option>
				</mat-selection-list>
				<ng-template #spinner>
					<app-spinner [text]="loadingBrandTxt"></app-spinner>
				</ng-template>
			</div>
			<!-- SELECT MODEL -->
			<div class="col-sm-3" [class.loading]="isLoading">
				<mat-selection-list [multiple]="false" (selectionChange)="onSelectionModel($event)" class="p-0"
					*ngIf="models.length > 0; else helper">
					<mat-list-option *ngFor="let model of models; trackBy: trackById" [value]="model" [selected]="isModelSelected(model)">
						{{model.name}}
					</mat-list-option>
				</mat-selection-list>
				<ng-template #helper>
					<div class="helper rounded" *ngIf="!isLoading; else spinnerModel">
						<div class="text-center">Choisis ta marque</div>
						<img src="assets/images/back-drawn-arrow.svg" alt="arrow" class="img-fluid" width="100">
					</div>
				</ng-template>
				<ng-template #spinnerModel>
					<div class="mt-3">
						<app-spinner [text]="loadingModelTxt"></app-spinner>
					</div>
				</ng-template>
			</div>
			<!-- CARD -->
			<div class="col-sm-6">
				<div class="model-card" *ngIf="model; else helperModel">
					<app-model-detail [model]="model"></app-model-detail>
				</div>
				<ng-template #helperModel>
					<div class="helper rounded" [class.opacity]="helperModelOpacityCls">
						<div class="text-center">Choisis ton modèle</div>
						<img src="assets/images/back-drawn-arrow.svg" alt="arrow" class="img-fluid" width="100">
					</div>
				</ng-template>
			</div>
		</div>
	</div>
</div>